var r=(e=>(e.APPROVED="Approved",e.REJECTED="Rejected",e))(r||{});export{r as a};
//# sourceMappingURL=chunk-YVBEQ4QF.mjs.map